import styled from 'styled-components';

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme?.spacing?.md ?? '16px'};
  flex-wrap: wrap;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 200px;
  max-width: 257px;
`;

export const ClearButtonWrapper = styled.div`
  display: flex;
  align-items: stretch;
  align-self: stretch;

  & > * {
    height: 100%;
    min-height: 100%;
  }
`;
